<template>
  <div class="header" id="idHeader">
    <div class="header-wrap">
      <nav class="nav-wrapper-phone">
        <div style="padding: 22px 5.6%;" id="menuHeader">
          <a class="menu">
            <img src="@/assets/images/menu.png" style="width:28px;" alt="menu" @click="onMenu" />
          </a>
          <a href="#" class="logo">
            <img style="width:80px;" src="@/assets/logo.png" alt="logo" />
          </a>
        </div>
      </nav>
      <transition name="fade">
      <div class="menuList" v-if="isMenu">
         <ul>
            <li v-for="(item,index) in titleData" :key="index" @click="onFocus(index)">
              <a :class="{focusActivity:focusItem==index}" :href="item.url">
                {{item.title}}
                <span class="hoverLine" :class="{focusActivity:focusItem==index}"></span>
              </a>
              <!-- <span class="hoverLine"></span> -->
            </li>
          </ul>
      </div>
      </transition>
      <nav class="nav-wrapper-pc">
        <a href="#" class="logo">
          <img style="width:112px;" :src="logo" alt="logo" />
        </a>
        <div class="head-right" id="headeLink">
          <ul>
            <li v-for="(item,index) in titleData" :key="index" @click="onFocus(index)">
              <a :class="{activity:isScoll === true,focusActivity:focusItem==index}" :href="item.url">
                {{item.title}}
                <span class="hoverLine" :class="{focusActivity:focusItem==index}"></span>
              </a>
              <!-- <span class="hoverLine"></span> -->
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleData: {
      type: Array,
      default: () => [],
    },
    focusItem:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      isScoll: true,
      logo:require("../assets/logo.png"),
      isMenu:false,
      // focusItem:0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.console.log("destroyed");
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageXOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let headerHeight = window.innerHeight;
      if (scrollTop > headerHeight-200) {
        document.getElementById("idHeader").style.background = "#Ffffff";
        document.getElementById("menuHeader").style.background = "#fd5a01";
        this.isScoll = false;
        document.getElementById("idHeader").style.opacity = 1;
        this.logo = require('../assets/logoScroll.png')
      } else {
        this.isScoll = true;
        document.getElementById("idHeader").style.background = "none";
        document.getElementById("menuHeader").style.background = "none";
        this.logo = require('../assets/logo.png')
      }
    },
  onFocus(index){
    this.$emit("onFocus",index)
  },
  onMenu(){
   this.isMenu = !this.isMenu
  }
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.header {
  // position: relative;
  z-index: 2;
  width: 100%;
  position: fixed;
  z-index: 9999;
}
.header-wrap {
  width: 1200px;
  margin: 0 auto;
}
.nav-wrapper-phone {
  display: none;
  position: absolute;
  width: 100%;

  a > img {
    vertical-align: middle;
  }

  .logo {
    position: absolute;
    left: 50%;
    margin-left: -30px;
  }
}

.nav-wrapper-pc {
  display: none;
  // padding: 20px;
  .head-right {
    a {
      text-decoration: none;
      color: #999999;
      padding: 20px 30px;
      letter-spacing: 1px;
      text-align: center;
      font-family: webfont;
      // width: 140px;
      .hoverLine {
      display: block !important;
      height: 3px;
      background: #fd5a01;
      display: none;
      transition: 0.5s;
      border-radius: 50px;
      width: 0px;
      margin-top: 10px;
    }
    }
    a + a {
      margin-left: 20px;
    }
  }
}
.head-right ul {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  li {
    list-style-type: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    a:hover {
      color: #fd5a01 !important;
      .hoverLine{
      width: 100% !important;
    }
    }
  }
}

//  li:hover{
//   color: #fd5a01;
//   }
.activity {
  color: #ffffff !important;
}
.focusActivity{
  color: #fd5a01 !important;
  width: 100% !important;
}
// .menuList{
//   display: none;
// }
 .menuList{
    // background: #ffffff;
    // background: #000000;
    background:rgba(0,0,0,0.7);
    position: fixed;
    top: 60px;
    z-index: 9999;
    ul{
      padding: 0;
      li{
        list-style: none;
        padding: 15px 20px;
       a{
          // color: #000000;
          color: #ffffff;
          text-decoration:none;
          font-size: 15px;
          letter-spacing: 0.5px;
       }
      }
    }
  }
@media (max-width: 767.98px) {
 .menuList{
   display: inline-block;
 }
  .nav-wrapper-phone {
    display: block;
  }
}

@media (min-width: 768px) {
  .header {
    position: fixed;
  }

  .nav-wrapper-pc {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>